module.exports = __webpack_public_path__ + "static/media/mimir2_logo_full.86530e05.png";